<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useVault } from './stores/vault.js';
import MarkGlyph from './components/MarkGlyph.vue';
import CollectionBar from './components/CollectionBar.vue';
import ToastBar from './components/ToastBar.vue';

const vault = useVault();
const route = useRoute();
const router = useRouter();

const TABS = [
  { to: '/add', label: 'Add' },
  { to: '/find', label: 'Find' },
  { to: '/shelf', label: 'Shelf' },
  { to: '/connect', label: 'Use in Claude' },
  { to: '/people', label: 'People' },
];

// Sign in, set a password and the consent screen stand alone: no collection bar,
// no tabs, nothing to scope.
const bare = computed(() => ['signin', 'set-password', 'consent', 'tool'].includes(route.name));

const initials = computed(() => (vault.user?.name ?? vault.user?.email ?? '?')
  .split(/[\s@.]+/).filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join(''));

const firstName = computed(() => (vault.user?.name ?? vault.user?.email ?? '').split(' ')[0]);

async function signOut() {
  await vault.signOut();
  router.push({ name: 'signin' });
}
</script>

<template>
  <template v-if="bare">
    <router-view />
  </template>

  <template v-else>
    <header class="idbar">
      <div class="shell">
        <MarkGlyph />
        <div class="name">Vault<small>devEco Consulting</small></div>
        <div class="push" />
        <div v-if="vault.user" class="me">
          <span class="pic">{{ initials }}</span>
          <span class="sr">signed in as</span>{{ firstName }}
          <button class="mini" style="margin-left:8px" @click="signOut">Sign out</button>
        </div>
      </div>
    </header>

    <CollectionBar />

    <nav class="tabs">
      <div class="shell">
        <router-link
          v-for="t in TABS" :key="t.to" :to="t.to" class="tab"
          :aria-current="route.path === t.to ? 'true' : undefined"
        >{{ t.label }}</router-link>
      </div>
    </nav>

    <main class="shell">
      <router-view v-if="vault.current || vault.isAll" />
      <div v-else class="panel">
        <h2>No collections yet</h2>
        <p class="hint">
          An owner puts you in one. Until then there is nothing here to search or add to.
        </p>
      </div>
    </main>
  </template>

  <ToastBar />
</template>

<style>
/* router-link renders an anchor where the mockup had a button. Same shape. */
.tabs .tab {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}
</style>
